var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCuttedLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 679,
    viewBox: "0 0 562 679",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 562,
    height: 679
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 562,
    height: 679,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.11 543.964L83.2059 679.647L242.797 679.292L163.11 543.964Z",
    fill: "#0089CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08636 271.959L-237 679.383H-77.1724L82.9903 407.642L3.08636 271.959Z",
    fill: "#0089CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.734 406.993L403.941 679.62H563L322.243 271.96L242.734 406.993Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.796 135.283L163.109 -0.0449219L83.2054 135.658L162.892 270.986L242.796 135.283Z",
    fill: "#FF0000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCuttedLogo);
export default __webpack_public_path__ + "static/media/ic_cutted_logo.f6292e83f3eac0f32402abf7e5b45ec4.svg";
export { ForwardRef as ReactComponent };